import { Button, Col, Row, Space, Table, Typography, Image } from "antd";
import React, { useState, useEffect } from "react";
import BreadCrumb from "../../atoms/BreadCrumb";
import DashboardLayout from "../../molecules/DashboardLayout";
import SectionHeader from "../../molecules/SectionHeader";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Popup } from "../../atoms/Popup";
//import AddRole from "./components/AddRole";
//import UpdateRole from "./components/UpdateRole";
//import AddUser from "./components/AddUser";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getApplication, getCMS } from "./ducks/actions";
import { adminService } from "../../../configs/constants";
import axios from "axios";
import { s3BucketUrl } from "../../../configs/constants";

const { Title, Text } = Typography;

const breadcrumbList: any = [
  {
    label: "CMS",
    route: "/cms",
  },
];

const Cms = (props) => {
  const dispatch = useDispatch();
  const cmsList = useSelector((state) => state.cms.cmsData);
  const appIds = useSelector((state) => state.roles.appData);
  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const [search, setSearch] = useState();
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [updateRow, setUpdateRow] = useState({});

  useEffect(() => {
    // dispatch(getCMS(1, ''));
    dispatch(getApplication());
  }, []);

  const addUser = () => {
    setVisible(true);
    setTrigger(1);
  };
  const addRole = () => {
    setVisible(true);
    setTrigger(0);
  };

  const onAddRole = () => {
    dispatch(getCMS(1, ""));
    setVisible(false);
  };

  const onUpdateRole = () => {
    dispatch(getCMS(1, ""));
    setVisible(false);
  };

  const updateCMSList = (data) => {
    history.push(`/cms/${data?.id}`);
  };

  const deleteCMSList = (data) => {
    const url = `${adminService}/cms/delete/${data?.id}`;
    try {
      axios.patch(url).then((res) => {
        dispatch(getCMS(1, ""));
      });
    } catch (e) {
      console.log(e);
    }
  };

  const onTopSearch = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    const filterData = () => {
      dispatch(getCMS(1, search));
    };
    const debouncer = setTimeout(() => {
      filterData();
    }, 1500);
    return () => {
      clearTimeout(debouncer);
    };
  }, [search]);

  const columns: any = [
    {
      title: "Title",
      dataIndex: "name",
      key: "name",
      //width: 220,
      render: (text, record) => (
        <Button
          type="link"
          className="p-0"
          onClick={() => history.push(`/cms/${record?.id}`)}
        >
          {text}
        </Button>
      ),
    },
    {
      title: "Key",
      dataIndex: "key",
      key: "key",
    },
    {
      title: "Media",
      dataIndex: "cms_media",
      render: (text, record) => {
        const staticImageURL = `${s3BucketUrl}/${record?.cms_media}`;
        return (
          <>
            <div className="centerImage">
              <Image
                width={90}
                src={staticImageURL}
                className="centerImage"
                fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                placeholder={
                  <Image preview={false} src={staticImageURL} width={250} />
                }
              />
            </div>
          </>
        );
      },
    },
    // {
    //   title: "Mega Tags",
    //   dataIndex: "meta_tag",
    //   key: "meta_tag",
    // },
    // {
    //   title: "Enable",
    //   dataIndex: "enable",
    //   key: "enable",
    //   width: 150,
    //   render: (text, record) => {
    //    return <Switch defaultChecked />
    //   },
    // },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      width: 150,
      render: (text, record) => {
        return (
          <Space size={16}>
            <Button
              type="link"
              onClick={() => updateCMSList(record)}
              className="p-0 ag-success"
            >
              <EditOutlined />
            </Button>
            {/* <Button type="link" onClick={()=>deleteCMSList(record)} danger className="p-0">
            <DeleteOutlined />
          </Button> */}
          </Space>
        );
      },
    },
  ];

  return (
    <>
      <DashboardLayout>
        {/* <Row gutter={[24, 24]}>
          <Col span={24}>
            <BreadCrumb list={breadcrumbList} />
          </Col>
        </Row> */}

        <SectionHeader
          heading="CMS"
          addText={"CMS"}
          search={onTopSearch}
          addNewAction={() => history.push("/add-cms")}
        />
        <Row gutter={24}>
          <Col span={24}>
            <Table
              className="custom-table"
              columns={columns}
              pagination={{
                className: "ag-property-text-pagination mb-1",
                position: ["topLeft"],
                pageSize: 50,
                showSizeChanger: false,
                onChange: (e) => {
                  setPage(e);
                  dispatch(getCMS(e, ""));
                },
                total: cmsList?.count,
                showTotal: (total, range) => `Showing ${range[1]}-${total} CMS`,
              }}
              dataSource={cmsList}
              scroll={{ y: 500 }}
            />
          </Col>
        </Row>
      </DashboardLayout>
    </>
  );
};

export default Cms;
